import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Small.scss';

const Small = (props) => {
  const {
    dark,
    primary,
    secondary,
    tertiary,
    medium,
    children,
    bold,
    block,
    className,
  } = props;

  const classes = {
    dark,
    primary,
    secondary,
    tertiary,
    small: true,
    bold,
    'display-block': block,
    medium,
  };

  return (
    <small className={classNames(classes, className)}>
      { children }
    </small>
  );
};

Small.defaultProps = {
  dark: false,
  primary: false,
  secondary: false,
  tertiary: false,
  medium: false,
  children: null,
  bold: false,
  block: false,
  className: '',
};

Small.propTypes = {

  /** Theme dark */
  dark: PropTypes.bool,

  /** Style primary */
  primary: PropTypes.bool,

  bold: PropTypes.bool,

  block: PropTypes.bool,

  /** Style secondary */
  secondary: PropTypes.bool,

  /** Style tertiary */
  tertiary: PropTypes.bool,

  className: PropTypes.string,

  medium: PropTypes.bool,
  children: PropTypes.node,
};

export default Small;
